import { Observable } from 'rxjs';

import { NotificationOutput } from 'infrastructure/graphql/messaging/notification/model/notification.output';

import { RequestMeetingCmd } from '../command/request-meeting.cmd';
import { SendMeetingAlternativeCmd } from '../command/send-meeting-alternative.cmd';

export abstract class NotificationApiPort {
	public abstract requestMeeting(cmd: RequestMeetingCmd): Observable<string>;

	public abstract fetchNotifications(): Observable<NotificationOutput[]>;

	public abstract markNotificationRead(id: string): Observable<void>;

	public abstract fetchNotification(id: string): Observable<NotificationOutput>;

	public abstract acceptMeeting(id: string): Observable<string>;

	public abstract rejectMeeting(id: string): Observable<void>;

	public abstract sendMeetingAlternative(
		cmd: SendMeetingAlternativeCmd
	): Observable<string>;

	public abstract cancelMeetingRequest(id: string): Observable<void>;

	public abstract markAllNotificationsRead(): Observable<string[]>;
}
